import { request } from '@/api/client';
import { ClientAuth } from '@/classes/ClientAuth';
import { UnauthorizedError } from '@/classes/Error';
import { API_URL, API_VERSION } from '@/constants';
import { User } from '@/types';

export async function getMyProfile(): Promise<User> {
  const data = await request<User>({
    url: `${API_URL}/api/${API_VERSION}/users/me`,
    init: { method: 'GET', headers: ClientAuth.headers, credentials: 'include' },
  });

  if (!data?.id || !data.email) {
    throw new UnauthorizedError();
  }

  return data;
}
